import { GetPlatformConfigResponse } from '../../../platform/server/api/admin/config/get-platform-config/get-platform-config.types';
import { useGetApi } from './use-get-api.hook';

export const useGetPlatformConfig = () => {
  return useGetApi<GetPlatformConfigResponse>('get-platform-config', {
    path: window.env.PLATFORM_URL + '/api/get-platform-config',
    refetchOnWindowFocus: true,
  });
};
